const deviceType = {
  state: {
    deviceTypeStatus: {}
  },
  mutations: {
    setDeviceTypeStatus: (state, data) => {
      state.deviceTypeStatus = data
    }
  },
  actions: {}
}
export default deviceType
